module.exports = __webpack_public_path__ + "img/background_c4-2.a3c1558b.jpg";